import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const UPDATE_PAYSLIP = gql`
  mutation UpdatePayslip($updatedPayslip: UpdatePayslipRequestDto!) {
    updatePayslip(updatedPayslip: $updatedPayslip) {
        bonus
        comment
        createdAt
        currency
        employeeContributions
        employerContributions
        grossSalary
        month
        netSalary
        paymentDate
        payslipFileUuid
        taxes
        uuid
        year
        
    }
  }
`;

export const useUpdatePayslip = () => {
    const [updatePayslip, { loading, error, data }] = useMutation(UPDATE_PAYSLIP);

    return { updatePayslip, loading, error, data };
};
